(function () {
  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-hs-garage-header-notifications]'));
  if (!roots.length) return;

  var storageKey = 'hsGarageDismissedNotifications';
  var notifications = [];

  roots.forEach(function (root) {
    if (root.dataset.customerLoggedIn !== 'true') return;

    var toggle = root.querySelector('[data-garage-header-notification-toggle]');
    var panel = root.querySelector('[data-garage-header-notification-panel]');

    if (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        togglePanel(root);
      });
    }

    if (panel) {
      panel.addEventListener('click', function (event) {
        var closeButton = event.target.closest('[data-garage-header-dismiss-notification]');
        if (!closeButton) return;

        event.preventDefault();
        dismissNotification(closeButton.dataset.garageHeaderDismissNotification);
        renderAll();
      });
    }
  });

  document.addEventListener('click', function (event) {
    roots.forEach(function (root) {
      if (root.contains(event.target)) return;
      closePanel(root);
    });
  });

  window.addEventListener('storage', function (event) {
    if (event.key === storageKey) renderAll();
  });

  window.addEventListener('hs-garage:notifications-updated', function (event) {
    if (event.detail && event.detail.source === 'header-read') return;
    renderAll();
  });

  loadNotifications();

  async function loadNotifications() {
    var activeRoot = roots.find(function (root) {
      return root.dataset.customerLoggedIn === 'true';
    });
    if (!activeRoot) return;

    try {
      var appUrl = activeRoot.dataset.appUrl || '/apps/garage/account';
      var response = await fetch(appUrl + '/notifications', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      var payload = await readJson(response);

      if (!response.ok) return;

      notifications = Array.isArray(payload.notifications) ? payload.notifications : [];
      renderAll();
    } catch (error) {
      notifications = [];
      renderAll();
    }
  }

  function renderAll() {
    var visibleNotifications = activeNotifications();

    roots.forEach(function (root) {
      renderRoot(root, visibleNotifications);
    });
  }

  function renderRoot(root, visibleNotifications) {
    var toggle = root.querySelector('[data-garage-header-notification-toggle]');
    var count = root.querySelector('[data-garage-header-notification-count]');
    var countLabel = root.querySelector('[data-garage-header-notification-label]');
    var panel = root.querySelector('[data-garage-header-notification-panel]');

    if (!toggle || !count || !panel || root.dataset.customerLoggedIn !== 'true') return;

    toggle.hidden = false;
    count.textContent = String(Math.min(visibleNotifications.length, 99));
    if (countLabel) countLabel.textContent = visibleNotifications.length === 1 ? 'nieuwe melding' : 'nieuwe meldingen';
    toggle.classList.toggle('is-read', !visibleNotifications.length);
    panel.innerHTML = panelTemplate(visibleNotifications);
  }

  function togglePanel(root) {
    var panel = root.querySelector('[data-garage-header-notification-panel]');
    var toggle = root.querySelector('[data-garage-header-notification-toggle]');
    if (!panel || !toggle) return;

    var shouldOpen = panel.hidden;
    roots.forEach(closePanel);

    panel.hidden = !shouldOpen;
    toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');

    if (shouldOpen) {
      markNotificationsRead(activeNotifications());
      roots.forEach(markRootRead);
    }
  }

  function closePanel(root) {
    var panel = root.querySelector('[data-garage-header-notification-panel]');
    var toggle = root.querySelector('[data-garage-header-notification-toggle]');
    if (panel) panel.hidden = true;
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.toggle('is-read', !activeNotifications().length);
    }
  }

  function activeNotifications() {
    return notifications.filter(function (notification) {
      return notification && notification.id && dismissedNotifications().indexOf(String(notification.id)) === -1;
    });
  }

  function panelTemplate(items) {
    var shown = items.slice(0, 5);

    return [
      '<div class="hs-garage-header-alert__head">',
      '<strong>Garage updates</strong>',
      '<span>' + items.length + (items.length === 1 ? ' nieuw' : ' nieuw') + '</span>',
      '</div>',
      shown.length ? '<div class="hs-garage-header-alert__list">' + shown.map(notificationTemplate).join('') + '</div>' : '<div class="hs-garage-header-alert__empty">Geen nieuwe garage-updates.</div>',
      '<a class="hs-garage-header-alert__link" href="/pages/mijn-garage">Bekijk mijn garage</a>',
    ].join('');
  }

  function notificationTemplate(notification) {
    var id = escapeHtml(notification.id || '');
    var title = escapeHtml(notification.title || 'Garage update');
    var message = escapeHtml(notification.message || '');
    var image = escapeHtml(notification.image || '');
    var url = escapeHtml(notification.url || '/pages/mijn-garage');

    return [
      '<article class="hs-garage-header-alert__item">',
      image ? '<img src="' + image + '" alt="" loading="lazy">' : '<span class="hs-garage-header-alert__icon">' + iconFor(notification.type) + '</span>',
      '<a href="' + url + '">',
      '<strong>' + title + '</strong>',
      message ? '<small>' + message + '</small>' : '',
      '</a>',
      '<button type="button" aria-label="Melding sluiten" data-garage-header-dismiss-notification="' + id + '">&times;</button>',
      '</article>',
    ].join('');
  }

  function iconFor(type) {
    if (type === 'favorite') return '★';
    if (type === 'comment' || type === 'reply') return '“';
    return '♥';
  }

  function dismissedNotifications() {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || '[]');
    } catch (error) {
      return [];
    }
  }

  function dismissNotification(id) {
    if (!id) return;

    try {
      var dismissed = dismissedNotifications();
      if (dismissed.indexOf(String(id)) === -1) {
        dismissed.push(String(id));
        localStorage.setItem(storageKey, JSON.stringify(dismissed.slice(-120)));
      }
    } catch (error) {
      return;
    }
  }

  function markNotificationsRead(items) {
    var ids = (items || []).map(function (notification) {
      return notification && notification.id ? String(notification.id) : '';
    }).filter(Boolean);

    if (!ids.length) return;

    try {
      var dismissed = dismissedNotifications();
      ids.forEach(function (id) {
        if (dismissed.indexOf(id) === -1) dismissed.push(id);
      });
      localStorage.setItem(storageKey, JSON.stringify(dismissed.slice(-120)));
      window.dispatchEvent(new CustomEvent('hs-garage:notifications-updated', { detail: { source: 'header-read' } }));
    } catch (error) {
      return;
    }
  }

  function markRootRead(root) {
    var toggle = root.querySelector('[data-garage-header-notification-toggle]');
    var count = root.querySelector('[data-garage-header-notification-count]');
    var countLabel = root.querySelector('[data-garage-header-notification-label]');
    if (!toggle || !count) return;

    toggle.classList.add('is-read');
    count.textContent = '0';
    if (countLabel) countLabel.textContent = 'nieuwe meldingen';
  }

  async function readJson(response) {
    var text = await response.text();
    if (!text) return {};

    try {
      return JSON.parse(text);
    } catch (error) {
      return {};
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
})();
